import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversClvComponent extends Component {
  @service organisation;
}
